import React from "react";
import {
  Box,
  Flex,
  VStack,
  HStack,
  Text,
  Heading,
  Button,
  Image,
  Circle,
  SimpleGrid,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Link,
  useColorModeValue,
  Container,
} from "@chakra-ui/react";
import { FaShieldAlt, FaExchangeAlt, FaUsers, FaGlobe } from "react-icons/fa";
import { motion } from "framer-motion";
import { NavLink, Link as RouterLink } from "react-router-dom";
import { PeerxLogo } from "../../components/icons/Icons";
import PricingPlans from "../../components/Billing/PricingPlans";

// Feature Icons and Descriptions
const FEATURES = [
  {
    title: "Trusted by Thousands",
    description: "Join a growing community of verified traders worldwide.",
    icon: FaUsers,
  },
  {
    title: "Secure Transactions",
    description: "Enjoy peace of mind with advanced encryption and verified users.",
    icon: FaShieldAlt,
  },
  {
    title: "Global Marketplace",
    description: "Access P2P trading across 100+ countries.",
    icon: FaGlobe,
  },
  {
    title: "Real-Time Exchange",
    description: "Fast, direct currency trading without intermediaries.",
    icon: FaExchangeAlt,
  },
];

// FAQ content
const FAQS = [
  {
    question: "How does PeerX ensure secure transactions?",
    answer:
      "PeerX verifies all users with KYC checks and implements trust-building features such as ratings and reviews.",
  },
  {
    question: "What happens if there is a dispute?",
    answer:
      "Users can raise disputes with documented evidence, and PeerX support will assist in mediation based on chat history and user feedback.",
  },
  {
    question: "Is there a free trial for the paid plans?",
    answer: "Yes, PeerX offers a 14-day free trial for all paid plans.",
  },
];

const LandingPage = () => {
  const textColor = useColorModeValue("gray.700", "white");
  const bgColor = useColorModeValue("background.100", "background.900");
  const cardBgColor = useColorModeValue("white", "gray.700");
  const accentColor = useColorModeValue("blue.500", "blue.300");

  return (
    <Box bg={bgColor} color={textColor} fontFamily="Poppins, sans-serif">
      {/* Navbar Section */}
{/*       <Flex
        as="nav"
        justify="space-between"
        align="center"
        p={{ base: "4", md: "6" }}
        bg="brand.300"
        wrap="wrap"
      >
        <Flex as={RouterLink} to="/" align="center" mr={{ base: "auto", md: 0 }}>
          <PeerxLogo h="30px" w="150px" />
        </Flex>

        <HStack
          display={{ base: "none", md: "flex" }}
          spacing={8}
          ml={{ md: "auto" }}
        >
          <NavLink to="#features" style={{ textDecoration: "none" }}>
            <Link color="white" _hover={{ textDecoration: "underline" }}>
              Features
            </Link>
          </NavLink>
          <NavLink to="#pricing" style={{ textDecoration: "none" }}>
            <Link color="white" _hover={{ textDecoration: "underline" }}>
              Pricing
            </Link>
          </NavLink>
          <NavLink to="#faq" style={{ textDecoration: "none" }}>
            <Link color="white" _hover={{ textDecoration: "underline" }}>
              FAQ
            </Link>
          </NavLink>
        </HStack>

        <Box mt={{ base: 2, md: 0 }}>
          <Button
            bg="white"
            color="blue.500"
            _hover={{ bg: "gray.200" }}
            as={RouterLink}
            to="/auth/sign-in"
          >
            Sign In
          </Button>
        </Box>
      </Flex> */}

      {/* Hero Section */}
{/*       <Box position="relative" bg="brand.300" pt={{ base: 12, md: 16 }}>
        <Container maxW="container.xl">
          <Flex
            direction={{ base: "column", md: "row" }}
            align="center"
            justify="space-between"
            wrap="wrap"
          >
            <VStack
              align="start"
              spacing={6}
              maxW={{ base: "100%", md: "600px" }}
              mb={{ base: 8, md: 0 }}
            >
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.8 }}
              >
                <Heading
                  fontSize={{ base: "3xl", md: "5xl" }}
                  color="white"
                  lineHeight="shorter"
                  fontWeight="bold"
                  textAlign={{ base: "center", md: "left" }}
                >
                  Trade Currencies Directly and Securely
                </Heading>
              </motion.div>
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1.2 }}
              >
                <Text
                  fontSize={{ base: "lg", md: "xl" }}
                  color="whiteAlpha.800"
                  textAlign={{ base: "center", md: "left" }}
                >
                  Join thousands of users on the leading Peer-to-Peer Currency
                  Exchange platform. Fast, secure, and community-driven.
                </Text>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1.6 }}
              >
                <HStack spacing={4} justify={{ base: "center", md: "flex-start" }}>
                  <Button
                    as={RouterLink}
                    to="/auth/sign-in"
                    size="lg"
                    bg="white"
                    color="blue.500"
                    _hover={{
                      transform: "scale(1.05)",
                      boxShadow: "xl",
                    }}
                  >
                    Get Started
                  </Button>
                  <Button
                    as={RouterLink}
                    to="/personal/listings"
                    size="lg"
                    variant="outline"
                    color="white"
                    borderColor="white"
                    _hover={{ bg: "whiteAlpha.300" }}
                  >
                    Explore Listings
                  </Button>
                </HStack>
              </motion.div>
            </VStack>
            <Image
              src="/fatheranddaughter.png"
              alt="Global Currency Exchange"
              w={{ base: "100%", md: "50%" }}
              mt={{ base: 8, md: 0 }}
              as={motion.img}
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.8 }}
            />
          </Flex>
        </Container>
      </Box> */}
      

      {/* Features Section */}
      <Box py={16} px={8} id="features" bg={cardBgColor}>
        <Container maxW="container.xl">
          <Heading textAlign="center" mb={10} color={textColor} fontSize="2xl">
            Why Choose PeerX?
          </Heading>
          <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={8}>
            {FEATURES.map((feature, index) => (
              <VStack
                key={index}
                bg={cardBgColor}
                p={8}
                borderRadius="md"
                shadow="lg"
                _hover={{ transform: "scale(1.05)", shadow: "xl" }}
              >
                <Circle size="60px" bg={accentColor} color="white">
                  <feature.icon size="30px" />
                </Circle>
                <Heading size="md" mt={4}>
                  {feature.title}
                </Heading>
                <Text textAlign="center" mt={2}>
                  {feature.description}
                </Text>
              </VStack>
            ))}
          </SimpleGrid>
        </Container>
      </Box>

      {/* Pricing Section */}
      <Box pt={16} id="pricing" bg="gray.100">
        <Container maxW="container.xl">
          <Heading textAlign="center" mb={10} color="teal.600" fontSize="2xl">
            Pricing Plans
          </Heading>
          <PricingPlans />
        </Container>
      </Box>

      {/* FAQ Section */}
      <Box py={16} px={8} id="faq" bg={useColorModeValue("gray.100", "gray.800")}>
        <Container maxW="container.md">
          <Heading textAlign="center" mb={10} color={textColor} fontSize="2xl">
            Frequently Asked Questions
          </Heading>
          <Accordion allowToggle>
            {FAQS.map((faq, index) => (
              <AccordionItem key={index}>
                <AccordionButton _expanded={{ bg: accentColor, color: "white" }}>
                  <Box flex="1" textAlign="left">
                    {faq.question}
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
                <AccordionPanel pb={4}>
                  {faq.answer}
                </AccordionPanel>
              </AccordionItem>
            ))}
          </Accordion>
        </Container>
      </Box>

      {/* Call-to-Action Section */}
      <Flex
        direction="column"
        align="center"
        justify="center"
        py={16}
        bg="blue.500"
        color="white"
        textAlign="center"
      >
        <Heading mb={4}>Ready to Join PeerX?</Heading>
        <Text mb={6}>
          Start your journey with the leading peer-to-peer currency exchange platform.
        </Text>
        <Button
          as={RouterLink}
          to="/auth/sign-up"
          size="lg"
          bg="white"
          color="blue.500"
          _hover={{ bg: "blue.100", transform: "scale(1.1)", shadow: "xl" }}
        >
          Sign Up Now
        </Button>
      </Flex>

      {/* Footer Section */}
      <Box bg="teal.600" py="40px">
        <Container maxW="container.xl"> {/* Added Container for footer */}
          <Flex justify="center" color="white" wrap="wrap"> {/* Added wrap */}
            <Text>&copy; 2024 PeerX. All Rights Reserved.</Text>
            <Link
              ml={{ base: 0, md: "20px" }} // Responsive margin left
              mt={{ base: 2, md: 0 }} // Responsive margin top
              href="#privacy"
              _hover={{ textDecoration: "underline" }}
              color="white"
            >
              Privacy Policy
            </Link>
          </Flex>
        </Container>
      </Box>
    </Box>
  );
};

export default LandingPage;